"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const routes_1 = require("~/consts/routes");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const events_1 = require("~/utils/events");
const utils_1 = require("~/utils/utils");
const consts_1 = require("~/components/Cad3d/consts");
const consts_2 = require("~/store/consts");
const assets_1 = require("~/assets");
const action_1 = require("~/store/account/action");
const useProjectStatus_1 = __importDefault(require("~/hooks/useProjectStatus"));
const types_1 = require("~/store/types");
const ProjectDetailsPopover_1 = __importDefault(require("~/components/ProjectManagement/ProjectDetailsPopover"));
const useProjectItemPath_1 = __importDefault(require("~/hooks/useProjectItemPath"));
const NewProjectModal_1 = __importDefault(require("~/components/ProjectManagement/NewProjectModal"));
const DuplicateProjectModal_1 = __importDefault(require("../ProjectManagement/DuplicateProjectModal"));
const AccountDropdown_1 = __importDefault(require("../Account/AccountDropdown/AccountDropdown"));
const Viewer_1 = __importDefault(require("../Cad3d/Viewer"));
const ToolboxButtonWithDropdown_1 = __importDefault(require("./ToolboxButtonWithDropdown"));
const ToolboxPanel_scss_1 = __importDefault(require("./ToolboxPanel.scss"));
const consts_3 = require("./consts");
function ToolboxPanel({ zoomViewerToFit, zoomViewerIn, zoomViewerOut, undoAction, redoAction, unselectObjectInViewer, numberOfFasteners, toggleWidgets, }) {
    var _a, _b;
    const undos = (0, react_redux_1.useSelector)(selectors_1.selectUndos);
    const redos = (0, react_redux_1.useSelector)(selectors_1.selectRedos);
    const BOMTotal = (0, react_redux_1.useSelector)(selectors_1.selectBOMTotal);
    const BOMDiscountedTotal = (0, react_redux_1.useSelector)(selectors_1.selectBOMDiscountedTotal);
    const BOMLoading = (0, react_redux_1.useSelector)(selectors_1.selectBOMLoading);
    const selectedTool = (0, react_redux_1.useSelector)(selectors_1.selectSelectedTool);
    const selectedTransformMode = (0, react_redux_1.useSelector)(selectors_1.selectSelectedTransformModes);
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const isCatalogShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.CATALOG_WIDGET));
    const isAIChatShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.AI_CHAT_WIDGET));
    const isBOMShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.BOM_WIDGET));
    const isBOMEditMode = (0, react_redux_1.useSelector)(selectors_1.selectBOMEditMode);
    const isItemPropertiesShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.ITEM_PROPERTIES_WIDGET));
    const isPreconfiguredFramesShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.PRECONFIGURED_FRAMES_WIDGET));
    const isImperialMeasurementUsed = (0, react_redux_1.useSelector)(selectors_1.selectIsImperialMeasurementUsed);
    const selectedItemsUUIDs = (0, react_redux_1.useSelector)(selectors_1.selectSelectedObjectsUUIDs);
    const currentProject = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProject);
    const exportQueue = (0, react_redux_1.useSelector)(selectors_1.selectExportQueue);
    const userId = (0, react_redux_1.useSelector)(selectors_1.selectUserId);
    const discountedPriceShown = (0, react_redux_1.useSelector)(selectors_1.selectBOMDiscountedPriceShown);
    const bomNeedsRecalculation = (0, react_redux_1.useSelector)(selectors_1.selectBomNeedsRecalculation);
    const isAiCopilotEnabled = (0, react_redux_1.useSelector)(selectors_1.selectIsAiCopilotEnabled);
    const isProjectItemPath = (0, useProjectItemPath_1.default)(projectId);
    let isScalable = false;
    let isRotatable = false;
    let isMovable = false;
    const selectedObjects = (_a = Viewer_1.default.instance.getDesignProMain()) === null || _a === void 0 ? void 0 : _a.selectionTool.selectedObjects;
    const { isOrderCompleted, isProjectArchived, isProjectViewOnly } = (0, useProjectStatus_1.default)();
    const leftCenter = 'left-center';
    let disabled = false;
    if (selectedObjects && selectedTool !== consts_2.TOOL_STATE.MEASURE) {
        [isScalable, isRotatable, isMovable] = Viewer_1.default.instance
            .getDesignProMain()
            .selectionTool.getIsScalableRotatableMovableParams();
    }
    const selectedBaseObject3D = selectedObjects;
    const isAngledSelected = selectedBaseObject3D && selectedBaseObject3D.length === 1 ? !!selectedBaseObject3D[0].scalingAngle : false;
    const disableFeatures = (_b = Viewer_1.default.instance.getDesignProMain()) === null || _b === void 0 ? void 0 : _b.disableFeatures;
    const { t } = (0, react_i18next_1.useTranslation)('common');
    const isUserLogged = (0, react_redux_1.useSelector)(selectors_1.selectIsUserLogged);
    const isDropdownShow = (0, react_redux_1.useSelector)(selectors_1.selectShowDropdown);
    const isProjectDetailsPopoverShown = (0, react_redux_1.useSelector)(selectors_1.selectShowProjectDetailsPopover);
    const currentAccountTab = (0, react_redux_1.useSelector)(selectors_1.selectCurrentTabId);
    const isShortcutsShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.SHORTCUTS_WIDGET));
    const isDefaultFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.DEFAULT_FASTENER_WIDGET));
    const isCurrentFastenersWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.CURRENT_FASTENER_WIDGET));
    const isItemReplacementWidgetShown = (0, react_redux_1.useSelector)((0, selectors_1.selectIsWidgetShown)(consts_2.WIDGETS.ITEM_REPLACEMENT_WIDGET));
    const isExportStepLoading = (0, react_redux_1.useSelector)(selectors_1.selectExportStepLoading);
    const exportStepProgress = (0, react_redux_1.useSelector)(selectors_1.selectExportStepProgress);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { dispatchTransformPanelTool, dispatchToggleWidget, dispatchUpdateWidgetPosition, dispatchSelectTool, dispatchSelectItem, dispatchContextMenu, dispatchToggleAccountDropDown, dispatchValidateTokenAction, dispatchToggleProjectDetailsPopover, dispatchSocketExportStep, dispatchRequestExportQueue, dispatchRequestRecalculateBOM, } = (0, redux_1.bindActionCreators)({
        dispatchTransformPanelTool: actions_1.transformPanelTool,
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchUpdateWidgetPosition: actions_1.updateWidgetPosition,
        dispatchSelectTool: actions_1.selectTool,
        dispatchSelectItem: actions_1.selectItem,
        dispatchContextMenu: actions_1.toggleContextMenu,
        dispatchToggleAccountDropDown: action_1.toggleAccountDropDown,
        dispatchValidateTokenAction: actions_1.validateTokenAction,
        dispatchToggleProjectDetailsPopover: actions_1.toggleProjectDetailsPopover,
        dispatchSocketExportStep: actions_1.requestSocketExportStep,
        dispatchRequestExportQueue: actions_1.requestExportQueue,
        dispatchRequestRecalculateBOM: actions_1.requestRecalculateBOM
    }, (0, react_redux_1.useDispatch)());
    const EXPORT_STEP_ENABLE_TIMEOUT = 1; // wait for 15s and enable export to step
    const [stepExportIsDisabled, setExportDisabled] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setExportDisabled(true);
        // Should be remove in User Story #191368 Improve UX of exporting to STEP
        const timeout = setTimeout(() => {
            setExportDisabled(false);
        }, EXPORT_STEP_ENABLE_TIMEOUT);
        return () => {
            clearTimeout(timeout);
        };
    }, [BOMTotal]);
    (0, react_1.useEffect)(() => {
        if (isUserLogged) {
            dispatchRequestExportQueue();
        }
    }, [projectId, isExportStepLoading]);
    const handleSelectToolClick = (id) => {
        switch (id) {
            case consts_3.SelectTool.SELECTED_TOOL_NAVIGATE:
                if (selectedTool === consts_2.TOOL_STATE.NAVIGATE) {
                    unselectObjectInViewer();
                }
                dispatchSelectTool(consts_2.TOOL_STATE.NAVIGATE);
                dispatchSelectItem(null);
                document.body.dispatchEvent(events_1.resetTransformationEvent);
                break;
            case consts_3.SelectTool.SELECTED_TOOL_PAN:
                dispatchSelectTool(consts_2.TOOL_STATE.PAN);
                break;
            case consts_3.SelectTool.SELECTED_TOOL_ROTATE:
                dispatchSelectTool(consts_2.TOOL_STATE.ROTATE_SCENE);
                break;
            case consts_3.SelectTool.SELECTED_TOOL_MEASURE:
                if (selectedTool === consts_2.TOOL_STATE.MEASURE) {
                    dispatchSelectTool(consts_2.TOOL_STATE.NAVIGATE);
                }
                else {
                    dispatchSelectTool(consts_2.TOOL_STATE.MEASURE);
                }
                break;
            default:
                break;
        }
        dispatchContextMenu({ show: false });
    };
    const handleSelectTransformModeClick = (id) => {
        switch (id) {
            case consts_3.SelectTransformMode.SELECTED_MODE_ROTATE:
                dispatchTransformPanelTool(consts_2.TRANSFORM_MODE.ROTATE);
                break;
            case consts_3.SelectTransformMode.SELECTED_MODE_RESIZE:
                dispatchTransformPanelTool(consts_2.TRANSFORM_MODE.SCALE);
                break;
            case consts_3.SelectTransformMode.SELECTED_MODE_TRANSLATE:
                dispatchTransformPanelTool(consts_2.TRANSFORM_MODE.TRANSLATE);
                break;
            default:
                break;
        }
        dispatchContextMenu({ show: false });
    };
    const handleFastenersClick = () => {
        if (selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS) {
            const action = {
                widgetName: consts_2.WIDGETS.RECOMMENDED_FASTENERS_WIDGET,
                show: false,
            };
            toggleWidgets(action);
            dispatchToggleWidget(action);
            dispatchSelectTool(consts_2.TOOL_STATE.NAVIGATE);
        }
        else {
            dispatchSelectTool(consts_2.TOOL_STATE.SHOW_FASTENERS);
        }
    };
    const closeNewProjectModal = () => {
        (0, events_1.hideModal)();
    };
    const handleQuoteClick = () => {
        dispatchToggleWidget({
            widgetName: consts_2.WIDGETS.BOM_WIDGET,
            show: !isBOMShown,
        });
        // eslint-disable-next-line no-unused-expressions
        isBOMEditMode &&
            isBOMShown === isCatalogShown &&
            dispatchToggleWidget({
                widgetName: consts_2.WIDGETS.CATALOG_WIDGET,
                show: !isCatalogShown,
            });
    };
    const handleRecalculateBOM = () => {
        if (!projectId) {
            return;
        }
        dispatchRequestRecalculateBOM({ projectId, userId });
    };
    const handleProfileClick = () => {
        if (isUserLogged && (0, utils_1.getIsUserLogged)()) {
            dispatchValidateTokenAction(() => navigate(routes_1.ROUTE_LOGIN));
            dispatchToggleAccountDropDown(!isDropdownShow);
        }
    };
    const handleCatalogClick = () => {
        dispatchToggleWidget({
            widgetName: consts_2.WIDGETS.CATALOG_WIDGET,
            show: !isCatalogShown,
        });
    };
    const hanndleAiChatClick = () => {
        if (!isUserLogged) {
            return;
        }
        if (!isAIChatShown) {
            dispatchUpdateWidgetPosition({
                widgetName: consts_2.WIDGETS.AI_CHAT_WIDGET,
                position: { x: 360, y: 0 },
            });
        }
        dispatchToggleWidget({
            widgetName: consts_2.WIDGETS.AI_CHAT_WIDGET,
            show: !isAIChatShown,
        });
    };
    const handlePropertiesClick = () => {
        dispatchToggleWidget({
            widgetName: consts_2.WIDGETS.ITEM_PROPERTIES_WIDGET,
            show: !isItemPropertiesShown,
        });
    };
    const handlePreconfiguredFramesClick = () => {
        dispatchToggleWidget({
            widgetName: consts_2.WIDGETS.PRECONFIGURED_FRAMES_WIDGET,
            show: !isPreconfiguredFramesShown,
        });
    };
    const handleProjectExport = (reduced = false) => {
        dispatchValidateTokenAction(() => navigate(routes_1.ROUTE_LOGIN));
        if (!isUserLogged) {
            navigate(routes_1.ROUTE_LOGIN, { state: { msg: 'Please sign in to export to STEP' } });
            return;
        }
        if (!projectId || !userId) {
            return;
        }
        (0, events_1.showNotification)({
            message: t('start-export'),
            type: 'info',
        });
        dispatchSocketExportStep({ projectId, userId, reduced });
        dispatchRequestExportQueue();
    };
    const handleDuplicateProject = () => {
        if (isUserLogged && currentProject) {
            (0, events_1.showModal)(react_1.default.createElement(DuplicateProjectModal_1.default, { project: currentProject, duplicatedFromToolbox: true }));
        }
    };
    const handleCreateNewProject = () => {
        if (isUserLogged) {
            (0, events_1.showModal)(react_1.default.createElement(NewProjectModal_1.default, { creation: true, closable: true, cancelHandler: closeNewProjectModal }));
        }
    };
    const swapMeasurementUnit = () => {
        Viewer_1.default.instance.setIsImperialMeasurementUnits(!isImperialMeasurementUsed);
    };
    const handleShortcutsClick = () => {
        dispatchToggleWidget({
            widgetName: consts_2.WIDGETS.SHORTCUTS_WIDGET,
            show: !isShortcutsShown,
        });
    };
    const getBOMTotal = () => {
        if (discountedPriceShown) {
            return BOMDiscountedTotal !== null && BOMDiscountedTotal !== void 0 ? BOMDiscountedTotal : BOMTotal;
        }
        return BOMTotal;
    };
    if (isProjectItemPath) {
        disabled = isOrderCompleted || isProjectArchived || isProjectViewOnly;
    }
    const exportDisabled = stepExportIsDisabled ||
        BOMLoading === types_1.LOADING_STATE.LOADING ||
        isBOMEditMode ||
        !projectId ||
        exportQueue.includes(projectId);
    const bomLabelValue = BOMTotal ? (0, utils_1.formatCurrencyLetters)(Number(getBOMTotal()), 2) : (0, utils_1.formatCurrencyLetters)(0, 2);
    const bomLabel = bomNeedsRecalculation ? 'Recalculate BOM' : bomLabelValue;
    const bomTooltipText = isBOMShown ? 'Hide Bill of Materials' : 'Show Bill of Materials';
    return (react_1.default.createElement("div", { className: ToolboxPanel_scss_1.default.toolboxPaneltoolboxPanel },
        react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.mainPanel}` },
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.logo}` },
                react_1.default.createElement("img", { src: assets_1.svgLogo, alt: "Toolbox panel" })),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.horizontalPanel}` },
                react_1.default.createElement(ToolboxButtonWithDropdown_1.default, { items: [
                        {
                            title: t('new-project'),
                            onClick: handleCreateNewProject,
                            icon: assets_1.svgProjectNewIcon,
                            disabled: !isUserLogged,
                        },
                        {
                            title: t('export-to-step'),
                            icon: assets_1.svgProjectStepIcon,
                            disabled: Number(BOMTotal) === 0 || exportDisabled,
                            isLoading: !!Number(BOMTotal) && exportDisabled,
                            progress: exportStepProgress.projectId === projectId ? exportStepProgress.progress : 0,
                            items: [
                                {
                                    title: t('export-to-full-step'),
                                    onClick: () => handleProjectExport(false),
                                    icon: assets_1.svgProjectStepIcon,
                                    disabled: Number(BOMTotal) === 0 || exportDisabled,
                                },
                                {
                                    title: t('export-to-reduced-step'),
                                    onClick: () => handleProjectExport(true),
                                    icon: assets_1.svgProjectStepIcon,
                                    disabled: Number(BOMTotal) === 0 || exportDisabled,
                                },
                            ],
                        },
                        {
                            title: t('duplicate-project'),
                            onClick: handleDuplicateProject,
                            icon: assets_1.svgProjectGeneralCopyIcon,
                            disabled: !isUserLogged || !projectId,
                        },
                    ] }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(UI_1.ToolButton, { "data-testid": "project-info-button", onKeyDown: () => dispatchToggleProjectDetailsPopover(!isProjectDetailsPopoverShown), onClick: () => dispatchToggleProjectDetailsPopover(!isProjectDetailsPopoverShown), active: isProjectDetailsPopoverShown, icon: assets_1.svgProjectInfoIcon, tooltip: { content: 'Project Info' }, "data-role": "horizontal-toolbox-buttons", disabled: !isUserLogged ||
                            !projectId ||
                            isDefaultFastenersWidgetShown ||
                            isCurrentFastenersWidgetShown ||
                            isItemReplacementWidgetShown ||
                            selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS }),
                    react_1.default.createElement("div", { className: ToolboxPanel_scss_1.default.projectInfo },
                        react_1.default.createElement(ProjectDetailsPopover_1.default, null))),
                isAiCopilotEnabled && (react_1.default.createElement(UI_1.ToolButton
                // icon={svgAIIcon}
                , { 
                    // icon={svgAIIcon}
                    className: ToolboxPanel_scss_1.default.aiButton, active: isUserLogged && isAIChatShown, disabled: !isUserLogged, tooltip: { content: isUserLogged ? 'AI' : 'Sign in to use AI' }, onClick: hanndleAiChatClick, title: "AI" }))),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.horizontalPanel}` },
                react_1.default.createElement(UI_1.ToolButton, { "data-testid": "toolbox-catalog-button", onKeyDown: handleCatalogClick, onClick: handleCatalogClick, icon: assets_1.svgCatalogWidget, active: isCatalogShown, "data-role": "horizontal-toolbox-buttons", disabled: isBOMEditMode ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS ||
                        disabled, tooltip: {
                        content: isCatalogShown ? 'Hide Catalog' : 'Show Catalog',
                    } }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: handlePropertiesClick, onClick: handlePropertiesClick, icon: assets_1.svgPropertiesWidgetIcon, active: isItemPropertiesShown, "data-role": "horizontal-toolbox-buttons", disabled: isBOMEditMode ||
                        selectedItemsUUIDs.length !== 1 ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS, tooltip: {
                        content: isItemPropertiesShown ? 'Hide properties' : 'Show properties',
                    } }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: handlePreconfiguredFramesClick, onClick: handlePreconfiguredFramesClick, icon: assets_1.svgKitsWidgetIcon, active: isPreconfiguredFramesShown, disabled: true, tooltip: {
                        content: isPreconfiguredFramesShown ? t('hide_preconfigured_frames') : t('show_preconfigured_frames'),
                    }, className: ToolboxPanel_scss_1.default.hidden, "data-role": "horizontal-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: handleFastenersClick, onClick: handleFastenersClick, icon: assets_1.svgFastenerModeIcon, id: "showFasteners", active: selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS, tooltip: {
                        content: selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS ? t('hide_fasteners') : t('show_fasteners'),
                    }, disabled: numberOfFasteners() === 0 ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown, "data-role": "horizontal-toolbox-buttons" })),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.horizontalPanel}` },
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: undoAction, onClick: undoAction, icon: assets_1.svgTransformUndoIcon, disabled: undos === 0 ||
                        isBOMEditMode ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS ||
                        disableFeatures ||
                        disabled, id: "undoCommand", tooltip: { content: 'Undo' }, "data-role": "horizontal-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: redoAction, onClick: redoAction, icon: assets_1.svgTransformRedoIcon, disabled: redos === 0 ||
                        isBOMEditMode ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS ||
                        disableFeatures ||
                        disabled, id: "redoCommand", tooltip: { content: 'Redo' }, "data-role": "horizontal-toolbox-buttons" })),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.horizontalPanel}` },
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: () => handleSelectTransformModeClick(consts_3.SelectTransformMode.SELECTED_MODE_ROTATE), onClick: () => handleSelectTransformModeClick(consts_3.SelectTransformMode.SELECTED_MODE_ROTATE), icon: assets_1.svgTransformRotateIcon, id: "selectedModeRotate", active: selectedTransformMode === consts_2.TRANSFORM_MODE.ROTATE, disabled: isBOMEditMode ||
                        selectedTransformMode === consts_2.TRANSFORM_MODE.NONE ||
                        !isRotatable ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS ||
                        disabled ||
                        isAngledSelected, tooltip: { content: 'Rotate' }, "data-role": "horizontal-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: () => handleSelectTransformModeClick(consts_3.SelectTransformMode.SELECTED_MODE_RESIZE), onClick: () => handleSelectTransformModeClick(consts_3.SelectTransformMode.SELECTED_MODE_RESIZE), icon: assets_1.svgTransformResizeIcon, id: "selectedModeResize", active: selectedTransformMode === consts_2.TRANSFORM_MODE.SCALE, disabled: isBOMEditMode ||
                        selectedTransformMode === consts_2.TRANSFORM_MODE.NONE ||
                        !isScalable ||
                        selectedItemsUUIDs.length > 1 ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS ||
                        disabled ||
                        isAngledSelected, tooltip: { content: 'Resize' }, "data-role": "horizontal-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: () => handleSelectTransformModeClick(consts_3.SelectTransformMode.SELECTED_MODE_TRANSLATE), onClick: () => handleSelectTransformModeClick(consts_3.SelectTransformMode.SELECTED_MODE_TRANSLATE), icon: assets_1.svgTransformMoveIcon, id: "selectedModeTranslate", active: selectedTransformMode === consts_2.TRANSFORM_MODE.TRANSLATE, disabled: isBOMEditMode ||
                        selectedTransformMode === consts_2.TRANSFORM_MODE.NONE ||
                        !isMovable ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS ||
                        disabled, tooltip: { content: 'Move' }, "data-role": "horizontal-toolbox-buttons" }))),
        process.env.NODE_ENV === 'development' && (react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.fps}` },
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { id: consts_1.consts.FPS_COUNTER_ID }, "0"),
                " fps"))),
        react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.quote}` },
            react_1.default.createElement(UI_1.ToolButton, { "data-testid": "toolbox-bom-button", onKeyDown: bomNeedsRecalculation ? handleRecalculateBOM : handleQuoteClick, onClick: bomNeedsRecalculation ? handleRecalculateBOM : handleQuoteClick, active: isBOMShown, icon: assets_1.svgQuoteWidgetIcon, label: bomLabel, loading: BOMLoading === types_1.LOADING_STATE.LOADING, disabled: isDefaultFastenersWidgetShown || isCurrentFastenersWidgetShown || isItemReplacementWidgetShown, tooltip: {
                    content: bomNeedsRecalculation ? 'Calculate BOM changes' : bomTooltipText,
                } })),
        react_1.default.createElement("div", { className: ToolboxPanel_scss_1.default.userControls, "data-active": (isDropdownShow || !!currentAccountTab) && isUserLogged },
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.user}` }, !isUserLogged ? (react_1.default.createElement(react_router_dom_1.Link, { to: routes_1.ROUTE_LOGIN, state: { msg: 'Please sign in to enable full experience' } },
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: handleProfileClick, onClick: handleProfileClick, icon: isUserLogged ? assets_1.svgProfileIcon : assets_1.svgLoginIco, "data-testid": "login-button" }))) : (react_1.default.createElement(UI_1.ToolButton, { onKeyDown: handleProfileClick, onClick: handleProfileClick, disabled: isDefaultFastenersWidgetShown || isCurrentFastenersWidgetShown || isItemReplacementWidgetShown, icon: isUserLogged ? assets_1.svgProfileIcon : assets_1.svgLoginIco }))),
            react_1.default.createElement("div", { className: ToolboxPanel_scss_1.default.account },
                react_1.default.createElement(AccountDropdown_1.default, null))),
        react_1.default.createElement("div", { className: ToolboxPanel_scss_1.default.rightPanel },
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.verticalPanel}` },
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_NAVIGATE), onClick: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_NAVIGATE), icon: assets_1.svgCameraSelectIcon, id: "selectedToolNavigate", active: selectedTool === consts_2.TOOL_STATE.NAVIGATE, tooltip: {
                        content: 'Select',
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_PAN), onClick: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_PAN), icon: assets_1.svgCameraPinchIcon, id: "selectedToolPan", active: selectedTool === consts_2.TOOL_STATE.PAN, tooltip: { content: 'Pan', placement: leftCenter }, "data-role": "vertical-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_ROTATE), onClick: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_ROTATE), icon: assets_1.svgCameraRotateIcon, id: "selectedToolRotate", active: selectedTool === consts_2.TOOL_STATE.ROTATE_SCENE, tooltip: {
                        content: 'Rotate',
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" })),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.verticalPanel}` },
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: zoomViewerToFit, onClick: zoomViewerToFit, icon: assets_1.svgZoomToFitIcon, id: "zoomToFit", tooltip: {
                        content: 'Zoom to Fit',
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: zoomViewerIn, onClick: zoomViewerIn, icon: assets_1.svgZoomInIcon, id: "zoomIn", tooltip: {
                        content: 'Zoom In',
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" }),
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: zoomViewerOut, onClick: zoomViewerOut, icon: assets_1.svgZoomOutIcon, id: "zoomOut", tooltip: {
                        content: 'Zoom Out',
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" })),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.singleButtonPanel} ${ToolboxPanel_scss_1.default.verticalPanel} ${ToolboxPanel_scss_1.default.measurementUnit}` },
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_MEASURE), onClick: () => handleSelectToolClick(consts_3.SelectTool.SELECTED_TOOL_MEASURE), icon: assets_1.svgTransformMeasurement, id: "selectedToolMeasure", active: selectedTool === consts_2.TOOL_STATE.MEASURE, disabled: isBOMEditMode ||
                        isDefaultFastenersWidgetShown ||
                        isCurrentFastenersWidgetShown ||
                        isItemReplacementWidgetShown ||
                        selectedTool === consts_2.TOOL_STATE.SHOW_FASTENERS, tooltip: {
                        content: t('measure'),
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" })),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.singleButtonPanel} ${ToolboxPanel_scss_1.default.verticalPanel} ${ToolboxPanel_scss_1.default.measurementUnit}` },
                react_1.default.createElement(UI_1.ToolButton, { onKeyDown: swapMeasurementUnit, onClick: swapMeasurementUnit, title: isImperialMeasurementUsed ? 'in' : 'mm', tooltip: {
                        content: 'Measurement unit',
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" })),
            react_1.default.createElement("div", { className: `${ToolboxPanel_scss_1.default.toolboxPanel} ${ToolboxPanel_scss_1.default.singleButtonPanel} ${ToolboxPanel_scss_1.default.verticalPanel}` },
                react_1.default.createElement(UI_1.ToolButton, { onClick: handleShortcutsClick, icon: assets_1.svgBasicHideCopy, active: isShortcutsShown, tooltip: {
                        content: `${isShortcutsShown ? t('hide_hot_keys') : t('show_hot_keys')}`,
                        placement: leftCenter,
                    }, "data-role": "vertical-toolbox-buttons" })))));
}
exports.default = ToolboxPanel;
